<template>
  <div class="container">
    <div class="product-listing">
      <div class="product-listing-controls pe-lg-5">
        <div class="d-flex justify-content-between flex-lg-column">
          <product-filters :filterGroups="filterGroups" :results="filteredProducts" :currentQuery="currentQuery">
            <template v-for="(_, name) in $slots" v-slot:[name]="slotData"><slot :name="name" v-bind="slotData" /></template>
          </product-filters>
          <product-sorts :sorts="sorts" :currentQuery="currentQuery">
            <template v-for="(_, name) in $slots" v-slot:[name]="slotData"><slot :name="name" v-bind="slotData" /></template>
          </product-sorts>
          <product-compare-button>
            <template v-for="(_, name) in $slots" v-slot:[name]="slotData"><slot :name="name" v-bind="slotData" /></template>
          </product-compare-button>
        </div>
      </div>

      <div class="product-listing-results product-card-container" aria-live="polite">
        <div class="row">
          <div v-for="product in filteredProducts" class="col-6 col-lg-4 mb-4">
            <product-result :product="product" :comparison="comparison" @removeFromComparison="removeFromComparison" @addToComparison="addToComparison">
              <template v-for="(_, name) in $slots" v-slot:[name]="slotData"><slot :name="name" v-bind="slotData" /></template>
            </product-result>
          </div>
        </div>
      </div>
      <div class="product-listing-cta pe-lg-5">
        <slot name="product-listing-retailer-button"></slot>
      </div>
    </div>
  </div>

  <product-compare-kicker :comparison="comparison" @clearComparison="clearComparison">
    <template v-for="(_, name) in $slots" v-slot:[name]="slotData"><slot :name="name" v-bind="slotData" /></template>
  </product-compare-kicker>

  <product-compare-drawer :comparison="comparison" :items="items" @removeFromComparison="removeFromComparison" @navigateToComparison="navigateToComparison" @compareDrawerOpen="compareDrawerOpen">
    <template v-for="(_, name) in $slots" v-slot:[name]="slotData"><slot :name="name" v-bind="slotData" /></template>
  </product-compare-drawer>

</template>

<script>
  import ProductFilters from './product-listing/product-filters.vue';
  import ProductSorts from './product-listing/product-sorts.vue';
  import ProductResult from './product-listing/product-result.vue';

  import ProductCompareButton from './product-listing/product-compare-button.vue';
  import ProductCompareKicker from './product-listing/product-compare-kicker.vue';
  import ProductCompareDrawer from './product-listing/product-compare-drawer.vue';

  import Globals from '../../scripts/globals';

  export default {
    components: {
      'product-filters': ProductFilters,
      'product-sorts': ProductSorts,
      'product-compare-button': ProductCompareButton,
      'product-compare-kicker': ProductCompareKicker,
      'product-compare-drawer': ProductCompareDrawer,
      'product-result': ProductResult
    },
    data() {
      let searchParams = new URLSearchParams(window.location.search)
      let d = window.wf.productListing
      // if (!d.currentQuery.filters || d.currentQuery.filters.length == 0) {
      //   d.currentQuery.filters = searchParams.get('filters') ? searchParams.get('filters').split(';') : [];
      // }
      d.currentQuery ??= {};
      d.currentQuery.filters ??= {};
      d.filterGroups.forEach((grp) => {
        if (!d.currentQuery.filters[grp.id] || d.currentQuery.filters[grp.id].length == 0) {
          d.currentQuery.filters[grp.id] = searchParams.get(`filter_${grp.id}`) ? searchParams.get(`filter_${grp.id}`).split(';') : [];
        }
        // ensure all items have at least an empty filter
        d.items.forEach((item) => {
          if (!item.filterValues[grp.id]) {
            item.filterValues[grp.id] = [];
          }
        })
      })
      if (!d.currentQuery.sort) {
        d.currentQuery.sort = searchParams.get('sort') ?? d.sorts.find(a => true).value;
      }
      d.comparison.a ??= searchParams.get('comparison_a');
      d.comparison.b ??= searchParams.get('comparison_b');
      return d;
    },
    computed: {
      filteredProducts() {
        return this.filterByQuery(this.currentQuery);
        // return this.products.filter((a) => {
        //   return this.currentQuery.filters.length == 0 ? true : (a.filterValues.filter((b) => this.currentQuery.filters.includes(b))).length == this.currentQuery.filters.length;
        // }).sort((a, b) => {
        //   if (this.currentQuery.sort.match(/\-reverse$/)) {
        //     let sortKey = this.currentQuery.sort.replace(/\-reverse$/, '');
        //     return b.sortValues[sortKey] - a.sortValues[sortKey];
        //   } else {
        //     return a.sortValues[this.currentQuery.sort] - b.sortValues[this.currentQuery.sort];
        //   }
        // })
      },
      comparisonHasSpace() {
        return Object.values(this.comparison).includes(null);
      }
    },
    watch: {
      currentQuery: {
        handler: function() {
          this.updateLocation();
        },
        deep: true
      },
      comparison: {
        handler: function() {
          this.updateLocation();
        },
        deep: true
      }
    },
    methods: {
      filterByQuery(query) {
        let filtered = this.items.filter((item) => {
          let match = true;
          this.filterGroups.forEach((grp) => {
            let groupMatch = (query.filters[grp.id].length == 0 || item.filterValues[grp.id].length == 0) ? true : (item.filterValues[grp.id].filter((b) => query.filters[grp.id].includes(b))).length > 0;
            match &&= groupMatch;
          });
          return match;
        })
        if (query.sort) {
          filtered.sort((a, b) => {
            let sortKey = query.sort.replace(/\-reverse$/, '');
            let aVal = a[sortKey],
              bVal = b[sortKey];
            if (sortKey == 'date') {
              aVal = Date.parse(aVal);
              bVal = Date.parse(bVal);
            }
            return (aVal < bVal ? -1 : (aVal > bVal ? 1 : 0)) * (query.sort.match(/\-reverse$/) ? -1 : 1);
          });
        }
        return filtered;
      },
      updateLocation() {
        let queryString = new URLSearchParams();
        this.filterGroups.forEach((grp) => {
          if (this.currentQuery.filters[grp.id] && this.currentQuery.filters[grp.id].length) {
            queryString.append(`filter_${grp.id}`, this.currentQuery.filters[grp.id].join(';'))
          }
        })
        queryString.append('sort', this.currentQuery.sort);
        if (this.comparison.a) queryString.append('comparison_a', this.comparison.a);
        if (this.comparison.b) queryString.append('comparison_b', this.comparison.b);
        window.history.replaceState(window.history.state, null, `${window.location.pathname}?${queryString.toString()}`);
      },
      addToComparison(product_id) {
        if (this.comparisonHasSpace) {
          for (let key in this.comparison) {
            if (this.comparison[key] == null) {
              this.comparison[key] = product_id;
              return;
            }
          }
        }
      },
      removeFromComparison(product_id) {
        for (let key in this.comparison) {
          if (this.comparison[key] && this.comparison[key] == product_id) {
            this.comparison[key] = null
          }
        }
      },
      navigateToComparison() {
        let queryString = new URLSearchParams();
        for (let key in this.comparison) {
          if (this.comparison[key] != null) {
            queryString.append(`product_${key}`, this.comparison[key]);
          }
        }
        window.location = `${this.comparisonUrl}?${ queryString.toString() }`
      },
      clearComparison() {
        for (let key in this.comparison) {
          this.comparison[key] = null;
        }
      },
      compareDrawerOpen() {
        console.log(Globals.breakpoints);
        if (window.innerWidth < Globals.breakpoints.lg) {
          window.location.hash = "";
          window.location.hash = "products";
        }
      }
    }
  }
</script>